export var JoveChatCoversationTypeEnum;

(function (JoveChatCoversationTypeEnum) {
  JoveChatCoversationTypeEnum["ai"] = "ai";
  JoveChatCoversationTypeEnum["agent"] = "agent";
})(JoveChatCoversationTypeEnum || (JoveChatCoversationTypeEnum = {}));

export var JoveChatMessageSenderRoleEnum;

(function (JoveChatMessageSenderRoleEnum) {
  JoveChatMessageSenderRoleEnum["customer"] = "customer";
  JoveChatMessageSenderRoleEnum["ai"] = "ai";
  JoveChatMessageSenderRoleEnum["agent"] = "agent";
  JoveChatMessageSenderRoleEnum["whatsapp"] = "whatsapp";
})(JoveChatMessageSenderRoleEnum || (JoveChatMessageSenderRoleEnum = {}));

export var JoveChatMessageResponseModeEnum;

(function (JoveChatMessageResponseModeEnum) {
  JoveChatMessageResponseModeEnum["ai"] = "ai";
  JoveChatMessageResponseModeEnum["agent"] = "agent";
})(JoveChatMessageResponseModeEnum || (JoveChatMessageResponseModeEnum = {}));